import { ReactElement } from 'react';

import { IColumn, PINNED } from '@private/data-grid';

import BinaryCell from 'components/Grids/DataGrid/Cells/BinaryCell';
import HeaderCell from 'components/Grids/DataGrid/Cells/HeaderCell';
import RowCell from 'components/Grids/DataGrid/Cells/RowCell';

export type TRenderHeaderCellProps<T> = {
  columns: IColumn<T>[];
  enableColumnStretch: boolean;
  index: number;
  isStretched: boolean;
  onToggleColumnStretch: () => void;
};

export type TRenderRowCellProps<T> = {
  dataKey: keyof T;
  isStretched: boolean;
  item: T;
  pinned?: ICenter | PINNED;
  rowIndex: number;
};

type ICenter = 'center';

export const renderHeaderCell = <T,>(params: TRenderHeaderCellProps<T>): ReactElement => (
  <HeaderCell {...params} />
);

export const renderCenterHeaderCell = <T,>(
  params: TRenderHeaderCellProps<T>,
): ReactElement => <HeaderCell center {...params} />;

export const renderEmptyHeaderCell = <T,>(
  params: TRenderHeaderCellProps<T>,
): ReactElement => <HeaderCell {...params} isEmpty />;

export const renderRowCell = <T,>(params: TRenderRowCellProps<T>): ReactElement => (
  <RowCell {...params} />
);

export const renderCenterRowCell = <T,>(params: TRenderRowCellProps<T>): ReactElement => (
  <RowCell center {...params} />
);

export const renderBinaryCell = <T,>(params: TRenderRowCellProps<T>): ReactElement => (
  <BinaryCell {...params} />
);
